module.exports = __webpack_public_path__ + "static/media/Yamask_gaussian2.9b4cc690.png";